import store from "./components/Stores/SurveyStore";
import ibsStore from "./components/Stores/IbsSurveyStore"
import sharedStore from "./components/Stores/SharedStore"
import { IbsCountries, IbsPartnerships, SelectCombosIBS, DBStyles, AssetCategoryIDs, AssetTableViewMode } from "./Enums/constants";
import { getNormalizedSelectInput } from "./helpers";
import { toast } from "react-toastify";
import { saveInputValueDC } from "./Services/IBS/IbsService";
import { IDENTITY_CONFIG_LOCAL } from "./Enums/authConstants";
import { saveInputValueDB } from "./Services/IBS/DbService";
import { getSurveyResponseValue, setSurveyResponseValue } from "./Helpers/General/SurveyResponsesHelper";

export function triggerMandateOnlyMode() {
    ibsStore.mandateOnlyView = !ibsStore.mandateOnlyView;
   
}

export function showHideOptionalMandateColumns() {
    ibsStore.showOptionalMandateColumns = !ibsStore.showOptionalMandateColumns;
    if (ibsStore.showOptionalMandateColumns) {
        toast('Showing optional columns. Scroll right to view.', {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.INFO,
            draggable: false,
            autoClose: 3000,
            hideProgressBar: true,
            className: "info-notif"
        });
    }
}

export function addNewMandate() {
    store.addingNewMandate = true;
    store.showMandateActionModal = true;
    store.showAssetOptions = true;

}
export function addNewBenchmark() {
    //store.addingNewMandate = true;
    store.showMandateActionModal = true;
    store.showAssetOptions = true;

}
export function getOptionsArray(optionsDict) {
    let optionsSource = []
    //if equities only push 1,3,5 etc optionsNeeded [1,3,5] <-iterate and add appropriately
    for (var key in optionsDict) {
        if (optionsDict.hasOwnProperty(key)) {
            optionsSource.push(optionsDict[key]);
        }
    }
    //options.push({ "Gross of reported costs", "Net of managers fees", "Net of all costs"})
    return optionsSource
}

export function getCustomGroupingConstituents(customAssetID) {
    let listOfMandatesFound = ibsStore.mandateData.filter(e => { return e.customAssetID == customAssetID })
    let listOfAssetsFound = ibsStore.allTableResponses["combinedAssets"].filter(e => { return e.CustomAssetID == customAssetID })
    let listOfConstituents = []
    listOfMandatesFound.forEach(mandate => {
        listOfConstituents.push(mandate.managerName + " - " + mandate.fundName)
    })
    listOfAssetsFound.forEach(asset => {
        listOfConstituents.push(asset.AssetClassName + " - " + asset.StyleName)
    })
    return listOfConstituents
}
export function sumOfConstituentsNAV(customAssetID) {
    let listOfMandatesFound = ibsStore.mandateData.filter(e => { return e.customAssetID == customAssetID })
    let listOfAssetsFound = ibsStore.allTableResponses["combinedAssets"].filter(e => { return e.CustomAssetID == customAssetID })

    let sumOfNav = 0;
    listOfMandatesFound.forEach(mandate => {
        sumOfNav = sumOfNav + mandate.holdingNavAvg
    })
    listOfAssetsFound.forEach(asset => {
        sumOfNav = sumOfNav + asset.HoldingsMillions
    })
    return sumOfNav
}
export function sumOfInternalTeamsNAV(internalTeamID) {
    let listOfMandatesFound = ibsStore.mandateData.filter(e => { return e.internalTeamID == internalTeamID })
    let listOfAssetsFound = ibsStore.allTableResponses["combinedAssets"].filter(e => { return e.InternalTeamID == internalTeamID })

    let sumOfNav = 0;
    if (ibsStore.checkMandateLevel == 1 || ibsStore.checkMandateLevel == 2) {
        listOfMandatesFound.forEach(mandate => {
            sumOfNav = sumOfNav + mandate.holdingNavAvg
        })
    }
    if (ibsStore.checkMandateLevel == 0 || ibsStore.checkMandateLevel == 2) {
        listOfAssetsFound.forEach(asset => {
            sumOfNav = sumOfNav + asset.HoldingsMillions
        })
    }
    
    return sumOfNav
}

export function getVintageYearOptions() {
    let years = []
    let end = ibsStore.currentSurvey.DataYear;
    years = [...Array(13).keys()].map(i => end - i);
    return years
}
export function returnTypesOnlyFirst3() {
    let optionsAvail = {}
    Object.assign(optionsAvail, SelectCombosIBS.ASSET_RETURN_TYPES);
    delete optionsAvail[4]
    delete optionsAvail[5]
    return optionsAvail
}

export function returnTypeIDOptions(rowID, isAssetRow = false) {
    let assetCat = ""
    if (rowID && isAssetRow) {
        let row = ibsStore.allTableResponses["combinedAssets"].find(e => { return e.RowID == rowID })
        assetCat = row.AssetClassCategoryName
    }
    else if (rowID && rowID.toString().charAt(0) == "A") {
        let row = ibsStore.allTableResponses["combinedAssets"].find(e => { return e.RowID == rowID.substring(1) })
        assetCat = row.AssetClassCategoryName

    } else {
        let row = ibsStore.mandateData.find(e => { return e.rowID == rowID })
        assetCat = row?.assetClassCategoryName

    }
    let optionsAvail = {}

    //add to list here or not depending  
    Object.assign(optionsAvail, SelectCombosIBS.ASSET_RETURN_TYPES);
    if (assetCat == "Equities" || assetCat == "Bonds") {
        delete optionsAvail[4]
        delete optionsAvail[5]
    }
    return optionsAvail
}

export function internalTeamOptions() {
    let teamNames = ["..."];
    ibsStore.allTableResponses["FrontOffice"] && ibsStore.allTableResponses["FrontOffice"].forEach(team => {
        teamNames.push(team.TeamName ?? "");
    })
    teamNames.push("Add or edit teams")
    return (teamNames)
}
export function mandateRegionOptions() {
    let regions = ["..."];
    if (sharedStore?.mandateRegions?.length > 0) {
        sharedStore.mandateRegions.forEach((region) => {
            regions.push(region.regionName ?? '');
        });
    }
    return (regions)
}
export function mandateSubstyleOptions(subStylesObj) {
    let substyles = ["..."];
    if (subStylesObj) {
        subStylesObj && subStylesObj.forEach(subStyle => {
            substyles.push(subStyle.subStyleName ?? "");
        })
    } else {
        sharedStore && sharedStore.mandateSubstyles.forEach(subStyle => {
            substyles.push(subStyle.subStyleName ?? "");
        })
    }
    
    return (substyles)
}
export function mandateSubstylesForAsset(assetClassID, assetCategoryID) {
    if (assetClassID=="" || assetCategoryID=="") return []
    let exists = sharedStore.mandateSubstyles.some(function (item) {
        return assetClassID === item.assetClassID;
    });
    let mandateSubstylesForRow
    if (exists) {
        mandateSubstylesForRow = sharedStore.mandateSubstyles.filter(function (value) {
            return assetClassID == value.assetClassID;
        });
    } else {
        mandateSubstylesForRow = sharedStore.mandateSubstyles.filter(function (value) {
            return assetCategoryID  == value.assetClassCategoryID;
        });
    }

    let filteredList = mandateSubstyleOptions(mandateSubstylesForRow)
    return filteredList
}

export function mandateSubstylesForAssetChosenRemoved(assetClassID, assetCategoryID) {
    let list = mandateSubstylesForAsset(assetClassID, assetCategoryID)
    
    let itemsToRemove = ibsStore.mandateModalInfo.MandateSubstyles;

    for (let i = list.length - 1; i >= 0; i--) {
        if (itemsToRemove.includes(list[i])) {
            list.splice(i, 1);
        }
    }

    return list

}

export function customGroupingOptions() {
    let customAssetOptions = ["..."];
    ibsStore.allTableResponses["CustomGroupings"] && ibsStore.allTableResponses["CustomGroupings"].forEach(asset => {
        customAssetOptions.push(asset.CustomAssetName)
    })
    customAssetOptions.push("Add or edit groupings")

    return (customAssetOptions)
}

export function allAssetClasses() {
    if (ibsStore.allTableResponses["AssetClassCategoriesMap"] && ibsStore.allTableResponses["AssetClassCategoriesMap"] !== {}) {
        return Object.keys(ibsStore.allTableResponses["AssetClassCategoriesMap"]);
    }
    else {
        return ["AssetCategories", "are not", "loaded"];
    }
}

/**
 * sort function helper for mandate
 * @param a
 * @param b
 * @param propertyName the key for the value from a and b
 * @returns {number}
 */
function localeCompareMandateProperties(a, b, propertyName) {
    const assetClassNameA = a[propertyName] ?? "";
    const assetClassNameB = b[propertyName] ?? "";
    return assetClassNameA.localeCompare(assetClassNameB);
}

/**
 * Will Sort by AssetClassCategory's DisplayOrder and then by AssetClassName
 * @param a 
 * @param b
 * @returns {number}
 */
export function DbSortFunctionForMandateAssets(a, b) {
    const categoryDisplayOrderA = GetMandateAssetCategoryDisplayOrder(a);
    const categoryDisplayOrderB = GetMandateAssetCategoryDisplayOrder(b);
    if (categoryDisplayOrderA === categoryDisplayOrderB) {
        // category display order is the same, now sort by asset class name

        const assetClassNameCompareValue = localeCompareMandateProperties(a, b, "assetClassName");
        if (assetClassNameCompareValue === 0) {
            // Asset class name is the same, now sort by style name

            const styleNameCompareValue = localeCompareMandateProperties(a, b, "styleName");
            if (styleNameCompareValue === 0) {
                // Style name is the same, now sort by manager name

                const managerNameCompareValue = localeCompareMandateProperties(a, b, "managerName");
                if (managerNameCompareValue === 0) {
                    // Manager name is the same, now sort by fundName
                    return localeCompareMandateProperties(a, b, "fundName");
                } else {
                    return managerNameCompareValue;
                }
            } else {
                return styleNameCompareValue
            }
        } else {
            return assetClassNameCompareValue;
        }
    } else {
        return (categoryDisplayOrderA < categoryDisplayOrderB) ? -1 : 1;
    }
}

/**
 * Made as a helper for DbSortFunctionForAssets. Gets the display order based on asset's categoryId only
 * @see DbSortFunctionForAssets
 * @param mandate assets containing "AssetClassCategoryID" property
 * @returns {Promise<*>} the display order retrieved based on the asset's categoryId
 */
export function GetMandateAssetCategoryDisplayOrder(mandate) {
    const categoryIdFromAsset = mandate["assetClassCategoryID"];
    const assetClassCategoryInfo = ibsStore.assetClassCategories.find(
        storeItem => storeItem["assetClassCategoryID"] === categoryIdFromAsset
    );

    return assetClassCategoryInfo["categoryDisplayOrder"];
}

/**
 * Will Sort by AssetClassCategory's DisplayOrder and then by AssetClassName
 * @param a 
 * @param b
 * @returns {number}
 */
export function DbSortFunctionForAssets(a, b) {
    const categoryDisplayOrderA = GetAssetCategoryDisplayOrder(a);
    const categoryDisplayOrderB = GetAssetCategoryDisplayOrder(b);

    if (categoryDisplayOrderA === categoryDisplayOrderB) {
        // category display order is the same
        // now sort by asset class name
        // TODO if sort by name isn't satisfactory, use DisplayOrder column in DBAssetClass table, it will result in slightly different

        const assetClassNameA = a["AssetClassName"];
        const assetClassNameB = b["AssetClassName"];

        return assetClassNameA.localeCompare(assetClassNameB);
    }
    else {
        return (categoryDisplayOrderA < categoryDisplayOrderB) ? -1 : 1;
    }
}

/**
 * Made as a helper for DbSortFunctionForAssets. Gets the display order based on asset's categoryId only
 * @see DbSortFunctionForAssets
 * @param asset assets containing "AssetClassCategoryID" property
 * @returns {number} the display order retrieved based on the asset's categoryId
 */
export function GetAssetCategoryDisplayOrder(asset) {
    const categoryIdFromAsset = asset["AssetClassCategoryID"];
    const assetClassCategoryInfo = ibsStore.assetClassCategories.find(
        storeItem => storeItem["assetClassCategoryID"] === categoryIdFromAsset
    );

    return assetClassCategoryInfo["categoryDisplayOrder"];
}

export function convertGrossNetReturnOptionToID() {

}

export function mapInternalTeam(internalTeamId) {
    let teamName = "";
    let foundTeam = ""
    if (ibsStore.allTableResponses["FrontOffice"]) {
        foundTeam = ibsStore.allTableResponses["FrontOffice"].find(team => team.RowID === internalTeamId);
        if (foundTeam) teamName = foundTeam.TeamName;
    }
    return teamName;
}
export function mapCustomGroupings (customAssetID) {
    let customAsset = "";
    let foundCG = ""

    if (customAssetID == null) {
        return null;
    }

    if (ibsStore.allTableResponses["CustomGroupings"]) {
        foundCG = ibsStore.allTableResponses["CustomGroupings"].find(team => team.CustomAssetID === customAssetID);
       
    }
    if (foundCG) {
        customAsset = foundCG.CustomAssetName;
    }

    return customAsset;
}
export function mapIDToName(table, IdValue, IdName, valueNeeded) {
    let foundItem = ""
    if (table && IdValue) {
        foundItem = table.find(item => item[IdName] === IdValue);

    }
    if (foundItem) return foundItem[valueNeeded];
    return null
}

export function convertTeamToID(qId, newValue) {
    let teamID = undefined;
    let foundTeam;
    // Null is reserved for dropdown no option, any null team names are turned into empty string
    if (newValue === null) {
        // this feels wrong but the function returns undefined in this case intentionally
        return "";
    }
    // Turn "" back into null and search for null teams. This logic will need to be reversed or updated if "" becomes a valid teamname instead of null.
    // Probablly should update the logic for the entire dropdown
    if (newValue === "") {
        newValue === null;
    }

    if (ibsStore.allTableResponses["FrontOffice"]) {
        foundTeam = ibsStore.allTableResponses["FrontOffice"].find(team => team.TeamName === newValue);

    }

    if (foundTeam) teamID = foundTeam.RowID
    return teamID

}

export function convertCustomGroupingToID(qId, newValue) {
    let customAssetID = null;
    let foundCG;

    if (newValue == null) {
        return null;
    }

    if (ibsStore.allTableResponses["CustomGroupings"]) {
        foundCG = ibsStore.allTableResponses["CustomGroupings"].find(team => team.CustomAssetName === newValue);

    }
    if (foundCG) {
        customAssetID = foundCG.CustomAssetID
    }

    return customAssetID;
    
}

export function convertMandateRegionToID(qId, newValue) {
    let mandateRegion = undefined;
    let foundCG;
    if (sharedStore.mandateRegions) {
        foundCG = sharedStore.mandateRegions.find(region => region.regionName === newValue);

    }
    if (foundCG) mandateRegion = foundCG.mandateRegionID
    return mandateRegion

}
export function convertMandateSubstyleToID(qId, newValue) {
    let mandateStyle = undefined;
    let foundCG;
    if (sharedStore.mandateSubstyles) {
        foundCG = sharedStore.mandateSubstyles.find(item => item.subStyleName === newValue);

    }
    if (foundCG) mandateStyle = foundCG.subStyleID
    return mandateStyle

}



export function setMandateTableValue(result, questionName, value) {
    ibsStore.mandateData[result][questionName] = value //retest this (does it cause rerender still)
}

export function mapToDropdownOption(id, options) {
    let normalizedVal = getNormalizedSelectInput(id, options)
    return (normalizedVal)
}

export function mapToGrossReturn(returnTypeIdAssets) {
    let normalizedRetTypeID = getNormalizedSelectInput(returnTypeIdAssets, SelectCombosIBS.ASSET_RETURN_TYPES)
    return (normalizedRetTypeID)
}

export function mapToLifeCycle(returnTypeId) {
    let normalizedRetTypeID = getNormalizedSelectInput(returnTypeId, SelectCombosIBS.LIFECYCLE_TYPES)
    return (normalizedRetTypeID)
}


export function mapToPERegionID(regionID) {
    let normalizedRegionID = getNormalizedSelectInput(regionID, SelectCombosIBS.PRIVATE_EQUITY_REGIONS)
    return (normalizedRegionID)
}


export function isInternalStyle(styleID) {
    switch (styleID) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 11:
        case 14:
            return true;
            break;
        default:
            return false;
    }

}

export function isDerivativesCategory(catName) {
    //test!!
    if (catName === "Derivatives/Overlays") {
        return true;
    }
    return false;
}

export function isLGPS() {
    if (ibsStore.currentSurvey?.PlanPartnershipID === IbsPartnerships.LGPS) {
        return true;
    }
    return false;
}
export function isAPRA() {
    if (ibsStore.currentSurvey?.PlanPartnershipID === IbsPartnerships.APRA) {
        return true;
    }
    return false;
}

export function showTemplates() {
    //pull this value from the database, controlled on laundromat
    let templatesTabAvailable = ibsStore.currentSurvey.ForceTemplatesTab;
    if (ibsStore.accountInfo && ibsStore.currentSurvey) {
        if (ibsStore.accountInfo.UserRoleID === 3) {
            let isMandateLevel = getSurveyResponseValue("IsMandateLevel")
            if (`${isMandateLevel}` === '1' || `${isMandateLevel}` === '2' || templatesTabAvailable) {
                if (sharedStore.identityConfig === IDENTITY_CONFIG_LOCAL) {
                    return true;
                } else {
                    // push the templates tab live anyway
                    return true;
                }
            }
        }
    }
}

export function isUK() {
    if (ibsStore && ibsStore.currentSurvey && ibsStore.currentSurvey.CountryID === IbsCountries.UK) {
        return true;
    }
    return false;
}

export function checkSpecialSaveConfigs(participantType) {
    let configs = { rowId: null, tableName: null }

    if (participantType != undefined && (participantType.toString() == "0" || participantType.toString() == "1")) {
        let rowId = participantType
        let tableName = "PlanDesign"
        configs = { rowId: rowId, tableName: tableName }
    }
    return (configs)


}


export function handlePlanDesignSelectCase(props, currentValue) {
    //plan design
    var newValue = currentValue;
    if (props.participantType !== undefined && (props.participantType.toString() == "1" || props.participantType.toString() == "0") && ibsStore.allTableResponses && ibsStore.allTableResponses["PlanDesign"]) {
        var newData = ibsStore.allTableResponses["PlanDesign"].filter(obj => {
            return obj.ParticipantType == props.participantType
        })

        if (newData.length > 0) {
            newValue = newData[0][props.name]
        }
    }
    return newValue
}

export function getSpecialIBSNumInputs(props, currentValue) {
    var newValue = currentValue;
    if (props.participantType !== undefined && (props.participantType.toString() == "1" || props.participantType.toString() == "0") && ibsStore.allTableResponses && ibsStore.allTableResponses["PlanDesign"]) {
        var newData = ibsStore.allTableResponses["PlanDesign"].filter(obj => {
            return obj.ParticipantType == props.participantType
        })

        if (newData.length > 0) {
            newValue = newData[0][props.name]
        }
    }
    else if (props.name == "VoluntaryContributions") {
        //special case
        let responseValueAlt = ibsStore.allResponses["IsVoluntaryContributionsNA"]
        if (responseValueAlt == 1) newValue = "N/A"
    }
    return newValue;
}
export function handleSpecialNumOnChange(props, changedValue) {
    if (props.name == "VoluntaryContributions") {
        //special case
        let responseValueAlt = ibsStore.allResponses["IsVoluntaryContributionsNA"]
        if (changedValue != "N/A" && responseValueAlt == 1) setSurveyResponseValue("IsVoluntaryContributionsNA", 0, null, props)
    }
}

export function handleSpecialNumInputs(name, value, props) {

    if (name == "VoluntaryContributions") {
        if (store.local.naList.includes(value)) {
            setSurveyResponseValue("IsVoluntaryContributionsNA", 1, null, props)
            saveInputValueDC("IsVoluntaryContributionsNA", 1, null, null)
            return "0";
        } else {
            setSurveyResponseValue("IsVoluntaryContributionsNA", 0, null, props)
            saveInputValueDC("IsVoluntaryContributionsNA", 0, null, null)
        }

    }
    return value


}

export function hasMandatesCheck() {
    if (ibsStore.mandateData && ibsStore.mandateData.length > 0) ibsStore.hasMandateData = true;
    else ibsStore.hasMandateData = false;
}

export function updateLinkedPrivateEquityRow(managerName, fundName, vintageYear, styleID, mandateID) {
    //update the linked private equity row with any necessary data from its mandate
    if (styleID == 16) {
        let PeRow = ibsStore.allTableResponses["PrivateEquity"].find(obj => obj.MandateID == mandateID)

        let linkedRowID = null
        console.log(PeRow, ibsStore.allTableResponses["PrivateEquity"])
        if (PeRow) linkedRowID = PeRow.RowID

        if (PeRow) {
            saveInputValueDB("PartnershipName", managerName + " - " + fundName, "PrivateEquity", linkedRowID)
            PeRow.PartnershipName = managerName + " - " + fundName
            saveInputValueDB("DataYear", vintageYear, "PrivateEquity", linkedRowID)
            PeRow.DataYear = vintageYear

        }

    }
}

export function clearDictionary(dict) {
    var keys = Object.keys(dict);
    keys.forEach(function (key) {
        dict[key] = ""
    });
}

export function atLeastOneMandateHasLpAssets(){
    let mandatesWithLpAssets = ibsStore.mandateData?.filter(item => {
        return [AssetCategoryIDs.RealAssets, AssetCategoryIDs.PrivateEquity, AssetCategoryIDs.PrivateDebt].includes(item.assetClassCategoryID)
            && [DBStyles.LimitedPartnerships].includes(item.styleID);
    });
    return mandatesWithLpAssets?.length > 0
}

export function getIsDealTerms() {
    let assetTabViewMode = parseInt(ibsStore.checkMandateLevel, 10);
    let assetTabViewModeIsMandateOnly = assetTabViewMode === AssetTableViewMode.MANDATE_ONLY_VIEW;
    let assetTabViewModeIsBothAndContainsAnLPMandate = assetTabViewMode ===  AssetTableViewMode.BOTH_VIEW && atLeastOneMandateHasLpAssets();
    let isDealTerms = assetTabViewModeIsMandateOnly || assetTabViewModeIsBothAndContainsAnLPMandate;
    return isDealTerms
}

export function refreshDealTermsTab() {
    if (!(ibsStore.mandateData == null) && Array.isArray(ibsStore.mandateData)) {
        ibsStore.allTableResponses["PrivateDeals"] = ibsStore.mandateData.filter(item => {
            return [AssetCategoryIDs.RealAssets, AssetCategoryIDs.PrivateEquity, AssetCategoryIDs.PrivateDebt].includes(item.assetClassCategoryID)
                && [DBStyles.LimitedPartnerships].includes(item.styleID);
        });

        ibsStore.allTableResponses['PublicDeals'] = ibsStore.mandateData.filter(
            (item) => {
                if (
                    [AssetCategoryIDs.RealAssets, AssetCategoryIDs.PrivateEquity, AssetCategoryIDs.PrivateDebt].includes(item.assetClassCategoryID) &&
                    [DBStyles.LimitedPartnerships, DBStyles.CoInvestment, DBStyles.JointVenture, DBStyles.FundofFunds].includes(item.styleID)
                ) {
                    return false;
                } else if ([DBStyles.InternalHedge, DBStyles.Internal_IP, DBStyles.OperatingSub, DBStyles.Unknown].includes(item.styleID)) {
                    return false;
                } else if ([AssetCategoryIDs.Derivatives].includes(item.assetClassCategoryID)) {
                    return false;
                } else {
                    return item
                }
            }
        );
    }

}